import { MessagesSquare } from 'lucide-react'
import { useParams } from 'react-router-dom'
import { cn } from '../../lib/cn'
import { ChatPanel } from './chat-panel'
import { ConversationList } from './conversation-list'

export function InboxPage() {
  const { conversationId } = useParams<{ conversationId: string }>()
  return (
    <section className="h-[calc(100svh-64px-72px)] overflow-hidden lg:h-svh">
      <div className="grid h-full lg:grid-cols-[360px_minmax(0,1fr)] xl:grid-cols-[400px_minmax(0,1fr)]">
        <div
          className={cn(
            'min-h-0 border-r border-[var(--border)] bg-[var(--surface)]',
            conversationId ? 'hidden lg:block' : 'block',
          )}
        >
          <ConversationList selectedConversationId={conversationId} />
        </div>
        <div className={cn('min-h-0', !conversationId && 'hidden lg:block')}>
          {conversationId ? (
            <ChatPanel conversationId={conversationId} />
          ) : (
            <div className="grid h-full place-items-center p-8">
              <div className="max-w-sm text-center">
                <div className="mx-auto grid size-16 place-items-center rounded-3xl bg-[var(--primary-soft)] text-[var(--primary)]">
                  <MessagesSquare className="size-7" />
                </div>
                <h1 className="mt-6 text-2xl font-semibold tracking-tight">
                  Seleziona una conversazione
                </h1>
                <p className="mt-3 text-base leading-7 text-[var(--muted-foreground)]">
                  Apri una chat dall’elenco per leggere lo storico e rispondere al cliente.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
